var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58333 3.3335H4.07407C3.6566 3.3335 3.25623 3.49934 2.96104 3.79453C2.66584 4.08973 2.5 4.4901 2.5 4.90757V15.9261C2.5 16.3436 2.66584 16.7439 2.96104 17.0391C3.25623 17.3343 3.6566 17.5002 4.07407 17.5002H15.0926C15.5101 17.5002 15.9104 17.3343 16.2056 17.0391C16.5008 16.7439 16.6667 16.3436 16.6667 15.9261V10.4168",
    stroke: "#8D8D8D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5552 2.1434C15.8604 1.83821 16.2743 1.66675 16.7059 1.66675C17.1376 1.66675 17.5515 1.83821 17.8567 2.1434C18.1619 2.4486 18.3333 2.86253 18.3333 3.29414C18.3333 3.72576 18.1619 4.13969 17.8567 4.44489L10.5686 11.7329L7.5 12.5001L8.26716 9.43144L15.5552 2.1434Z",
    stroke: "#8D8D8D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.787b81bf17e698cd0632a59a6f283418.svg";
export { ForwardRef as ReactComponent };